import { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n, { initPromise } from "./i18n";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);
  return null;
}

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <AppRoutes />
    </>
  );
}

function App() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Wait for i18n initialization promise
    initPromise
      .then(() => {
        console.log('✅ i18n initialized successfully');
        setIsReady(true);
      })
      .catch((error) => {
        console.error('❌ i18n initialization failed:', error);
        // Still set ready to show app, though translations might be broken
        setIsReady(true);
      });

    // Also set up a timeout fallback
    const timeoutId = setTimeout(() => {
      console.log('⏰ i18n initialization timeout - rendering anyway');
      setIsReady(true);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  // Show loading state until i18n is ready
  if (!isReady) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0A2540 0%, #1a3a5c 100%)',
        color: 'white',
        fontSize: '18px',
        fontFamily: 'Space Grotesk, sans-serif',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{ 
          width: '60px', 
          height: '60px', 
          border: '4px solid rgba(255,255,255,0.3)',
          borderTopColor: '#2C7DA0',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>Loading GTRA...</div>
          <div style={{ fontSize: '14px', opacity: 0.7 }}>
            Initializing translations...
          </div>
        </div>
      </div>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppContent />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
